import { i18nGlobal } from "@/setup/i18n";

const VALIDATION_DETAIL_PATTERN = /Value error,(.+?)\[type=/s;
const firstMessage = (value) => {
  if (typeof value === "string") return value;
  if (!value || typeof value !== "object") return "";
  return Object.values(value).map(firstMessage).find(Boolean) ?? "";
};

const fieldValidationMessage = (response) => {
  if (response?.status !== 400 || typeof response.data !== "object")
    return undefined;
  return firstMessage(response.data) || undefined;
};

export const extractErrorDetail = (error) => {
  if (error?.name === "QuotaExceededError")
    return i18nGlobal.t("deviceStorageFull");
  if (error?.name === "ResponseError") return "";
  const raw =
    error?.response?.data?.detail ??
    error?.response?.data?.error ??
    fieldValidationMessage(error?.response) ??
    error?.message ??
    "";
  if (typeof raw !== "string") return "";
  const validationError = VALIDATION_DETAIL_PATTERN.exec(raw);
  if (validationError) return validationError[1].trim();
  return raw
    .split("\n")[0]
    .replace(/^\[[^\]]+\]\s*/, "")
    .trim();
};
